export default __webpack_public_path__ + "static/media/1_0118.321e7be6.webp";